<template>
	<md-toolbar
		md-elevation="0"
		class="md-white md-fixed-top md-toolbar-fixed"
		:class="{'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute}"
	>
		<div class="md-toolbar-row">
			<div class="md-toolbar-section-start">
				<img :src="logo" alt="logoAnticimex" />
			</div>
			<div class="md-toolbar-section-end">

				<md-button
					class="md-just-icon md-round md-simple md-toolbar-toggle"
					:class="{ toggled: $sidebar.showSidebar }"
					@click="toggleSidebar"
				>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</md-button>

				<div class="md-collapse">
					<md-list>
						<md-list-item @mousedown="goToRoute($event, 'caProfile')">
							<p class="m-0 text-sm text-black font-medium">{{ client ? client.name : '' }}</p>
						</md-list-item>

						<md-list-item @click="logout">
							<i class="md-icon fas fa-sign-out-alt"></i>
						</md-list-item>
					</md-list>
				</div>

			</div>
		</div>
	</md-toolbar>
</template>

<script>

import logoAnticimex from "@/assets/images/logo.png"
import routerMixin from "@/mixins/router-mixin"
import {mapState} from "vuex";

export default {
	name: "Navbar",
	computed: mapState({
		client: state => state.caAuth.client,
		isIdle() {
			return this.$store.state.idleVue.isIdle
		},
	}),
    mixins: [ routerMixin ],
	data() {
		return {
			logo: logoAnticimex,
		}
	},
	methods: {
		toggleSidebar() {
			this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
		},
		minimizeSidebar() {
			if (this.$sidebar) {
				this.$sidebar.toggleMinimize();
			}
		},
		logout() {
			this.$store.dispatch("caLogout")
		},
	},
	created() {
		let count = setInterval(() => {
			if (this.isIdle) {
				this.$store.dispatch("updateSession")
				if (this.$store.getters["areaSessionTime"] === 0) {
					clearInterval(count)
					this.logout()
				}
			} else {
				this.$store.dispatch("resetSession")
			}
		}, 60000);
	},
}
</script>

<style lang="scss" scoped>
.md-toolbar {
	max-height: 70px;
	img {
		max-width: 25%;
	}
}
.md-collapse {
	.md-list-item, .md-list-item-button {
		transition: all 150ms ease-in;
		color: inherit !important;
		font-weight: 400 !important;
		font-size: 14px !important;
		overflow: visible !important;
		border-radius: 3px !important;
		position: relative !important;
		display: block !important;
		padding: 0 !important;
		text-decoration: none !important;

		svg {
			margin: 0 !important;
			line-height: 30px;
			min-width: 16px !important;
			font-size: 16px !important;
		}
	}
	.md-list-item:not(.bg-transparent):hover {
		background: rgba(200, 200, 200, 0.2) !important;
	}
	.md-list-item-button:hover {
		background-color: transparent !important;
	}

	.search {
		label {
			color: #FFFFFF !important;
		}
	}
}
</style>
